module.exports = __webpack_public_path__ + "static/media/Jaya.22b30a71.png";